<template>
  <div v-if="isSuperAdmin">
    <table class="table table-striped">
      <tbody>
        <tr>
          <td>Mettre à jour les valeurs caches de la table za_requirements</td>
          <td><button class="btn btn-primary" role='button' @click="exec('last_update_cache')">Executer</button></td>
        </tr>
        <tr>
          <td>Mettre à jour le statut des services pour refléter le meilleur statut parmi les dossiers qui y sont associés</td>
          <td><button class="btn btn-primary" role='button' @click="exec('update_service_statuses')">Executer</button></td>
        </tr>
        <tr>
          <td>Mettre à jour les billets pour permettre des due_date NULL, de type DATETIME</td>
          <td><button class="btn btn-primary" role='button' @click="exec('adjust_ticket_due_date_field')">Executer</button></td>
        </tr>
        <tr>
          <td>Ajouter le champ priority aux billets</td>
          <td><button class="btn btn-primary" role='button' @click="exec('add_ticket_priority_field')">Executer</button></td>
        </tr>
        <tr>
          <td>Changer le modified_at pour être le même que created_at au moment de création et modifier pour les modified_at erronnés</td>
          <td><button class="btn btn-primary" role='button' @click="exec('set_default_and_fix_zeroed_values_for_modified_at')">Executer</button></td>
        </tr>
        <tr>
          <td>Ajouter la table contacts et ajouter le champ are_report_contacts_active au fournisseur</td>
          <td><button class="btn btn-primary" role='button' @click="exec('add_contacts')">Executer</button></td>
        </tr>
        <tr>
          <td>Ajouter "revue préliminaire" dans les options de statut d'appréciation (d'exigences et de dossiers)</td>
          <td><button class="btn btn-primary" role='button' @click="exec('add_revue_preliminaire_status_key')">Executer</button></td>
        </tr>
        <tr>
          <td>Changer certains champs TIMESTAMP ou DATETIME à des champs DATE pour régler les effets indésirables des fuseaux horaires</td>
          <td><button class="btn btn-primary" role='button' @click="exec('change_columns_to_date_to_fix_timezone_issues')">Executer</button></td>
        </tr>
        <tr>
          <td>Supprimer le champ inutilisé ticket_priority_id</td>
          <td><button class="btn btn-primary" role='button' @click="exec('remove_ticket_priority_id_field')">Executer</button></td>
        </tr>
        <tr>
          <td>Supprimer la table inutilisé za_ticket_priority</td>
          <td><button class="btn btn-primary" role='button' @click="exec('remove_za_ticket_priority_table')">Executer</button></td>
        </tr>
        <tr>
          <td>Ajouter une priorité par défaut (Moyenne) aux billets avec cycle de vie manquant une valeur au champ priorité</td>
          <td><button class="btn btn-primary" role='button' @click="exec('set_default_priority_for_lifecycle_tickets')">Executer</button></td>
        </tr>
        <tr>
          <td>Supprimer la table attachment inutilisée</td>
          <td><button class="btn btn-primary" role='button' @click="exec('drop_attachments')">Executer</button></td>
        </tr>
        <tr>
          <td>Ajouter la table documents</td>
          <td><button class="btn btn-primary" role='button' @click="exec('add_documents')">Executer</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios';
import {privileges} from '@/mixins/privileges.js';

export default {
  data: function() {return {
    db_host: '',
    db: ''
  }},

  mixins: [privileges],

  methods: {

    exec: function(action) {
      axios
        .get(this.$root.$data.server_base + '/api/admin/'+action+'.php',
          { params: {}})
        .then(response => {
          this.$checkApiErrors(response.data);
        })
        .catch(error => {
          // console.log(error)
        })
    },
  },
  mounted () {
    // this.refresh();
  }
}
</script>
